import { render, staticRenderFns } from "./passwordForgotten.vue?vue&type=template&id=1ea5bade&scoped=true&"
import script from "./passwordForgotten.vue?vue&type=script&lang=js&"
export * from "./passwordForgotten.vue?vue&type=script&lang=js&"
import style0 from "./passwordForgotten.vue?vue&type=style&index=0&id=1ea5bade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5bade",
  null
  
)

export default component.exports